module.exports = __webpack_public_path__ + "static/mcBRONZE-6d1bf4981b02681175c7cf4e0b7e3ec8.png";